export const categoriesCache: string = 'categories';
export const categoriesWithTagsCache: string = 'categoriesWithTags';
export const LocationTagsCache = 'LocationTags';
export const adminActivitiesCache: string = 'adminActivities';
export const adminUsersCache: string = 'adminUsers';
export const adminUserStatsCache: string = 'adminUserStats';
export const adminUserSettingsCache: string = 'adminUserSettings';
export const adminTagsCache: string = 'adminTags';
export const adminCitiesCache: string = 'adminCities';
export const recommendationRebuildCache: string = 'recommendationRebuild';
export const adminTokenRulesCache: string = 'adminTokenRules';
export const adminTokenChangesCache: string = 'adminTokenChanges';
export const adminUserTokensCache: string = 'adminUserTokens';
export const adminTokenAbuseCache: string = 'adminTokenAbuse';
export const adminChallengesCache: string = 'adminChallenges';
export const adminChallengeTemplatesCache: string = 'adminChallengeTemplates';
export const adminSupportConversationsCache: string =
  'adminSupportConversations';
export const adminSupportMessagesCache: string = 'adminSupportMessages';
export const staticPreferencesCache: string = 'staticPreferences';
